<template>
  <el-row>
    <el-col :span="4">
      <el-popover placement="bottom" width="300" v-model="provinceVisible" trigger="manual">
        <ul class="province">
          <li class="province-item" v-for="(item,index) in provinceList" :key="index"
              :class="{active:info.province === item.value}" @click.stop="selectProvince(item,index)">
            {{item.label}}
          </li>
        </ul>
        <div slot="reference" style="width: 100%;">
          <el-input v-model.trim="info.province" placeholder="省" :disabled="disabled"
                    @focus="provinceFocus" @input="provinceInput" @blur="provinceBlur" maxLength="1"></el-input>
        </div>
      </el-popover>
    </el-col>
    <el-col :span="4" style="margin-left: 10px;">
      <el-popover placement="bottom" width="300" v-model="letterVisible" trigger="manual">
        <ul class="province">
          <li class="province-item" v-for="(item,index) in letterList" :key="index"
              :class="{active:info.letter === item.value}" @click.stop="selectLetter(item,index)">
            {{item.label}}
          </li>
        </ul>
        <div slot="reference" style="width: 100%;">
          <el-input class="click_input" v-model.trim="info.letter" placeholder="字母" :disabled="disabled"
                    @focus="letterFocus" @input="letterInput" @blur="letterBlur" maxLength="1"></el-input>
        </div>
      </el-popover>
    </el-col>
    <el-col :span="14" style="margin-left: 10px;">
      <el-input v-model.trim="info.licensePlateNumber" placeholder="请输入5/6位车牌号" :disabled="disabled"
                @blur="getCardNumber" @input="getCardNumber" maxLength="6"></el-input>
    </el-col>
  </el-row>
</template>

<script>
  export default {
    data() {
      return {
        info: {
          province: "",
          letter: "",
          licensePlateNumber: "",
          carNumber: ""
        },
        provinceList: [],
        letterList: [],
        provinceVisible: false,
        letterVisible: false
      };
    },
    created() {
      this.provinceList = this.province ? this.province : [];
      this.letterList = this.letter ? this.letter : [];
      this.info.province = this.provinceFather;
      this.info.letter = this.letterFather;
      this.info.licensePlateNumber = this.licensePlateNumberFather;
    },
    mounted() {

    },
    props: {
      value: {
        default: ""
      },
      provinceFather: {
        default: ""
      },
      letterFather: {
        default: ""
      },
      licensePlateNumberFather: {
        default: ""
      },
      disabled: {
        type: Boolean,
        default: false
      },
      province: {
        type: Array,
        default() {
          return [
            { "label": "京", "value": "京" }, { "label": "津", "value": "津" },
            { "label": "沪", "value": "沪" }, { "label": "渝", "value": "渝" },
            { "label": "冀", "value": "冀" }, { "label": "豫", "value": "豫" },
            { "label": "云", "value": "云" }, { "label": "辽", "value": "辽" },
            { "label": "黑", "value": "黑" }, { "label": "湘", "value": "湘" },
            { "label": "皖", "value": "皖" }, { "label": "鲁", "value": "鲁" },
            { "label": "新", "value": "新" }, { "label": "苏", "value": "苏" },
            { "label": "浙", "value": "浙" }, { "label": "赣", "value": "赣" },
            { "label": "鄂", "value": "鄂" }, { "label": "桂", "value": "桂" },
            { "label": "甘", "value": "甘" }, { "label": "晋", "value": "晋" },
            { "label": "蒙", "value": "蒙" }, { "label": "陕", "value": "陕" },
            { "label": "吉", "value": "吉" }, { "label": "闽", "value": "闽" },
            { "label": "贵", "value": "贵" }, { "label": "粤", "value": "粤" },
            { "label": "青", "value": "青" }, { "label": "藏", "value": "藏" },
            { "label": "川", "value": "川" }, { "label": "宁", "value": "宁" },
            { "label": "琼", "value": "琼" }, { "label": "使", "value": "使" },
            { "label": "领", "value": "领" }
          ];
        }
      },
      letter: {
        type: Array,
        default() {
          return [
            { "label": "A", "value": "A" }, { "label": "B", "value": "B" },
            { "label": "C", "value": "C" }, { "label": "D", "value": "D" },
            { "label": "E", "value": "E" }, { "label": "F", "value": "F" },
            { "label": "G", "value": "G" }, { "label": "H", "value": "H" },
            { "label": "I", "value": "I" }, { "label": "J", "value": "J" },
            { "label": "K", "value": "K" }, { "label": "L", "value": "L" },
            { "label": "M", "value": "M" }, { "label": "N", "value": "N" },
            { "label": "O", "value": "O" }, { "label": "P", "value": "P" },
            { "label": "Q", "value": "Q" }, { "label": "R", "value": "R" },
            { "label": "S", "value": "S" }, { "label": "T", "value": "T" },
            { "label": "U", "value": "U" }, { "label": "V", "value": "V" },
            { "label": "W", "value": "W" }, { "label": "X", "value": "X" },
            { "label": "Y", "value": "Y" }, { "label": "Z", "value": "Z" }
          ];
        }
      }
    },
    computed: {},
    methods: {
      provinceFocus() {
        if (this.disabled) {
          return;
        }
        this.provinceVisible = true;
        this.letterVisible = false;
      },
      provinceInput() {
        if (this.disabled) {
          return;
        }
        this.provinceVisible = true;
        let reg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领]{1}$/;
        if (!reg.test(this.info.province)) {
          this.info.province = "";
        }
        this.getCardNumber();
      },
      provinceBlur() {
        this.provinceVisible = false;
      },
      letterFocus() {
        if (this.type === 1) {
          return;
        }
        this.letterVisible = true;
        this.provinceVisible = false;
      },
      letterInput() {
        if (this.type === 1) {
          return;
        }
        this.letterVisible = true;
        let reg = /^[A-Z]{1}$/;
        if (!reg.test(this.info.letter)) {
          this.info.letter = "";
        }
        this.getCardNumber();
      },
      letterBlur() {
        this.letterVisible = false;
      },
      getCardNumber() {
        let info = this.info;
        this.info.carNumber = `${info.province ? info.province : ""}${info.letter ? info.letter : ""}${info.licensePlateNumber ? info.licensePlateNumber : ""}`;
        this.$emit("getCarNumber", info.province, info.letter, info.licensePlateNumber);
        this.$emit("input", this.info.carNumber);
      },
      selectProvince(row, index) {
        this.info.province = row.value;
        this.provinceVisible = false;
        this.getCardNumber();
      },
      selectLetter(row, index) {
        this.info.letter = row.value;
        this.letterVisible = false;
        this.getCardNumber();
      }
    },
    components: {},
    watch: {
      province: {
        handler(val) {
          this.letterList = this.letter ? this.letter : [];
        },
        immediate: true
      },
      letter: {
        handler(val) {
          this.provinceList = this.province ? this.province : [];
        },
        immediate: true
      }
    }
  };
</script>
<style scoped lang="scss">
  @import '../assets/css/mixin';

  .province {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;

    .province-item {
      cursor: pointer;
      padding: 5px;
      color: #333;
      /*transition: all .3s ease-in-out;*/
    }

    .province-item:hover, .province-item.active {
      color: #409eff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/card-number.vue